import React from 'react'

const Second_pane = () => {
  return (
    <div className='uk-margin-xlarge-top'>
        <div className='uk-container'>
            <h4 className='orange'>WHAT WE DO</h4>
            <div className='row'>
              <div className='col-sm-9  second_pane_div'>
                
         <h1 className='light'>We are the Pan-African innovation support organization
           that builds the systems, commercializes the research, and scales the 
           ventures shaping the continent’s future. 
  </h1>
              </div>
              <div className='col-sm-3'>

                </div>
            </div>

          
            <div className='row uk-margin-large-top'>
                <h2 className='light uk-text-bold'>Our Focus Areas</h2>



                 <div className='col-sm-6 uk-margin-small-top'>
                        <div className='border-orange'>
                             <div className='row'>
                                  <div className='col-sm-3'>
                                    <p></p>
                                  </div>

                                  <div className='col-sm-9'>
                                     <h4 className='light uk-text-bold'>Climate Change</h4>
                                     <p className='light'>We support initiatives that are developing 
                                        practical, climate-smart solutions that strengthen community
                                         resilience and advance national sustainability goals. Through
                                          targeted incubation, researches, partnerships, and technical
                                           guidance, we help to design and scale technologies that
                                            promote mitigation, adaptation, and equitable access to
                                             climate-resilient services.

</p>
                                    </div>
                             </div>
                        </div>
                 </div>

                 <div className='col-sm-6'>
                 <div className='border-orange'>
                             <div className='row'>
                                  <div className='col-sm-3'>
                                    <p></p>
                                  </div>

                                  <div className='col-sm-9'>
                                     <h4 className='light uk-text-bold'>Future of Food.</h4>
                                     <p className='light'>Moolu Venture Lab drives sustainable transformation
                                         across the agrifood system by supporting innovators and initiatives
                                          tackling challenges from climate impact to nutrition and waste. 
                                          Through inclusive collaboration, tailored incubation, and
                                           market-focused support, we help ideas grow into impactful, 
                                           scalable agrifood solutions.
 </p>
                                    </div>
                             </div>
                        </div>
                 </div>
            </div>






            <div className='row uk-margin-medium-top'>
                 <div className='col-sm-6'>
                        <div className='border-orange'>
                             <div className='row'>
                                  <div className='col-sm-3'>
                                   
                                  </div>

                                  <div className='col-sm-9'>
                                     <h4 className='light uk-text-bold'>Sustainable Energy</h4>
                                     <p className='light'>Africa’s path to decarbonisation depends on
                                         expanding sustainable, affordable energy systems across transport,
                                          housing, and industry. Moolu Venture Lab advances this transition
                                           by building clean-energy talent, supporting innovation and research,
                                            and accelerating ventures with the resources and networks needed to scale.
</p>
                                    </div>
                             </div>
                        </div>
                 </div>

                 <div className='col-sm-6'>
                          <div className='border-orange'>
                             <div className='row'>
                                  <div className='col-sm-3'>
                                   
                                  </div>

                                  <div className='col-sm-9'>
                                     <h4 className='light uk-text-bold'>Digitalization/ Emerging Technology</h4>
                                     <p className='light'>The digital transition offers immense potential when
                                         technologies like AI, machine learning, and advanced computing are
                                          applied responsibly for societal and environmental good. Moolu Venture
                                           Lab supports this future by nurturing digital talent, advancing
                                            breakthrough innovations, and accelerating deep-tech ventures
                                             with funding, mentoring, and market access.
</p>
                                    </div>
                             </div>
                        </div>
                 </div>
            </div>





            <div className='row uk-margin-medium-top'>
                 <div className='col-sm-6'>
                        <div className='border-orange'>
                             <div className='row'>
                                  <div className='col-sm-3'>
                                   
                                  </div>

                                  <div className='col-sm-9'>
                                     <h4 className='light uk-text-bold'>Gender focused Programming/intervention
</h4>
                                     <p className='light'>Moolu Venture Lab integrates gender-focused programming
                                         to address the structural barriers limiting women’s participation and 
                                         success in innovation, entrepreneurship, and technology. Through 
                                         targeted interventions, capacity-building, and equitable access to
                                          opportunities, we foster an inclusive ecosystem where women-led 
                                          ventures can thrive and scale.</p>
                                    </div>
                             </div>
                        </div>
                 </div>

                 <div className='col-sm-6'>
                         <div className='border-orange'>
                             <div className='row'>
                                  <div className='col-sm-3'>
                                   
                                  </div>

                                  <div className='col-sm-9'>
                                     <h4 className='light uk-text-bold'>Creative Sectors & Industries</h4>
                                     <p className='light'>Tech alone will not be enough to make
                                       “sustainability” tangible for the average Afrcan. It has
                                        to be something you can walk through, look at, listen to,
                                         and participate in. Something you can wear or live inside
                                          of. This requires the power of art and creativity.</p>
                                    </div>
                             </div>
                        </div>
                 </div>
            </div>





        </div>
    </div>
  )
}

export default Second_pane